const DEFAULT_API_VERSION = "v3";
export {
  DEFAULT_API_VERSION
};
